(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["beyza-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || window.customElements.get('beyza-size-guide')) return;

    class BeyzaSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this.trigger = this.querySelector('[data-bsg-open]');
        this.dialog = this.querySelector('[data-bsg-dialog]');
        if (!this.trigger || !this.dialog) return;
        this._ready = true;
        this.supported = typeof this.dialog.showModal === 'function';

        this._onOpen = this.open.bind(this);
        this._onClose = this.close.bind(this);
        this._onDialogClick = this.onDialogClick.bind(this);
        this._onDialogClosed = this.onDialogClosed.bind(this);
        this._onCancel = this.onCancel.bind(this);
        this._onKey = this.onKey.bind(this);
        this._onTrap = this.onTrap.bind(this);
        this._onSelect = this.open.bind(this);
        this._onDeselect = this.close.bind(this);

        this.trigger.addEventListener('click', this._onOpen);
        this.dialog.addEventListener('click', this._onDialogClick);
        this.dialog.addEventListener('close', this._onDialogClosed);
        this.dialog.addEventListener('cancel', this._onCancel);
        this.dialog.addEventListener('keydown', this._onTrap);
        this.addEventListener('shopify:block:select', this._onSelect);
        this.addEventListener('shopify:block:deselect', this._onDeselect);
      }

      disconnectedCallback() {
        if (!this._ready) return;
        this._ready = false;
        this.trigger.removeEventListener('click', this._onOpen);
        this.dialog.removeEventListener('click', this._onDialogClick);
        this.dialog.removeEventListener('close', this._onDialogClosed);
        this.dialog.removeEventListener('cancel', this._onCancel);
        this.dialog.removeEventListener('keydown', this._onTrap);
        this.removeEventListener('shopify:block:select', this._onSelect);
        this.removeEventListener('shopify:block:deselect', this._onDeselect);
        document.removeEventListener('keydown', this._onKey);
        if (this.dialog.open) this.close();
        this.unlock();
      }

      lock() {
        const root = document.documentElement;
        const gap = window.innerWidth - root.clientWidth;
        if (gap > 0) document.body.style.paddingRight = gap + 'px';
        root.classList.add('beyza-sg-lock');
      }

      unlock() {
        if (document.querySelector('.beyza-size-guide__dialog[open]')) return;
        document.documentElement.classList.remove('beyza-sg-lock');
        document.body.style.paddingRight = '';
      }

      open(event) {
        if (event && event.type === 'click') event.preventDefault();
        if (this.dialog.open) return;
        this.returnFocus = document.activeElement;
        if (this.supported) {
          this.dialog.showModal();
        } else {
          this.dialog.classList.add('is-fallback');
          this.dialog.setAttribute('open', '');
          document.addEventListener('keydown', this._onKey);
        }
        this.lock();
        this.trigger.setAttribute('aria-expanded', 'true');
        const close = this.dialog.querySelector('[data-bsg-close]');
        if (close) close.focus();
      }

      close() {
        if (!this.dialog.open) return;
        if (this.supported) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.dialog.classList.remove('is-fallback');
          document.removeEventListener('keydown', this._onKey);
          this.onDialogClosed();
        }
      }

      onDialogClosed() {
        this.unlock();
        this.trigger.setAttribute('aria-expanded', 'false');
        const target = this.returnFocus && this.returnFocus.isConnected ? this.returnFocus : this.trigger;
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }

      onCancel(event) {
        /* ESC: close through our own path so scroll + focus are always restored. */
        event.preventDefault();
        this.close();
      }

      onKey(event) {
        if (event.key === 'Escape') this.close();
      }

      /* Keep Tab / Shift+Tab cycling inside the open modal. */
      onTrap(event) {
        if (event.key !== 'Tab' || !this.dialog.open) return;
        const focusable = Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter((el) => el.offsetParent !== null || el === document.activeElement);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }

      onDialogClick(event) {
        if (event.target.closest('[data-bsg-close]')) {
          this.close();
          return;
        }
        /* Clicks on the dialog element itself (not its panel) are backdrop clicks. */
        if (event.target === this.dialog) this.close();
      }
    }

    window.customElements.define('beyza-size-guide', BeyzaSizeGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
